import React from 'react';
import { handleCheckoutMegapack } from '../utils/checkout';
interface CTAButtonProps {
  label: string;
  className?: string;
}
export function CTAButton({
  label,
  className = ''
}: CTAButtonProps) {
  return <button type="button" onClick={handleCheckoutMegapack} className={`w-full rounded-[11px] bg-gold px-6 py-3.5 text-center text-[13px] md:text-[14px] font-bold uppercase tracking-[0.06em] text-carbon transition-colors duration-150 ease-out hover:bg-gold-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-transparent ${className}`} style={{
    fontSize: "16px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    width: "332px"
  }} data-id="element-13" data-mp="2kyy3yiesci9h">
      {label}
    </button>;
}